import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UrlSignature } from '../common/apiEndPoint';
import { map } from 'rxjs/operators';

@Injectable()
export class CongratulationService {
  constructor(private httpClient: HttpClient, private urlSignature: UrlSignature) {}

  sendCongratulationEmail(mailingData: string): Observable<string> {
    const url = this.urlSignature.congratulationEmail;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.httpClient.post(url, mailingData, httpOptions).pipe(map((response) => response as string));
  }
}
